import { render, staticRenderFns } from "./AmbienceNumber.vue?vue&type=template&id=09bf00fc"
import script from "./AmbienceNumber.vue?vue&type=script&lang=js"
export * from "./AmbienceNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09bf00fc')) {
      api.createRecord('09bf00fc', component.options)
    } else {
      api.reload('09bf00fc', component.options)
    }
    module.hot.accept("./AmbienceNumber.vue?vue&type=template&id=09bf00fc", function () {
      api.rerender('09bf00fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/AmbienceNumber.vue"
export default component.exports